import React from 'react';
import type { ImageProps } from 'react-native';

import { Image } from '../Image';
import { getContentfulImageSources } from './getContentfulImageSources';

// ────────────────────────────────────────────────────────────────────────────────

export const ContentfulImage = React.memo((props: ContentfulImageProps) => {
  const { baseUrl, options, ...rest } = props;

  const sources = React.useMemo(() => {
    return getContentfulImageSources(baseUrl, options);
  }, [baseUrl, options]);

  return <Image source={sources} accessibilityIgnoresInvertColors {...rest} />;
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type ContentfulImageProps = {
  readonly baseUrl: string;
  readonly options: Parameters<typeof getContentfulImageSources>[1];
} & Omit<ImageProps, 'source'>;
